const session = {
    setValueSession(key, value) {
        if (value == null) {
            if (this.getValueSession(key) != null) {
                sessionStorage.removeItem(key);
            }
        } else {
            sessionStorage.setItem(key, value);
        }
    },
    removeValueSession(key) {
        sessionStorage.removeItem(key);
    },
    getValueSession(key) {
        return sessionStorage.getItem(key);
    },
    clearSession() {
        sessionStorage.clear();
    }
};

export default session;



// WEBPACK FOOTER //
// ./src/services/session.js